import * as actionTypes from '../../constants/actionTypes';
import {NEW_SCOPE_CATEGORIES_REQUEST, NEW_SCOPE_SET_NEW_FEATURE_GROUP_IMAGE} from "../../constants/actionTypes";
import { object } from 'prop-types';
import {AVAILABLE_VISUALIZERS} from "../../constants/dashboard";

const initialState = {
  qtCategories: [],
  qtCategoriesReceived: false,
  qtCategoryImageEditIndex: null, // category image edit popup index
  activeImageEditFeatureGroup: null, // feature group object (for image edit popup)
  activeQtCategoryIndex: 0,
  featureGroupsSearchValue: "",
  newFeatureGroupImage: "",
  categoriesVisualizer: AVAILABLE_VISUALIZERS.kitchen,
  qtCategoriesRequestCount: 0,
  fabricatorSubscriptions: [],
  fabricatorSubscriptionsReceived: false,
  isWizardMode: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.NEW_SCOPE_CATEGORIES_REQUEST:
      return Object.assign({}, state, {
        qtCategoriesRequestCount: ++state.qtCategoriesRequestCount,
        qtCategoriesReceived: false
      });
    case actionTypes.NEW_SCOPE_CATEGORIES_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        qtCategoriesReceived: true
      });
    case actionTypes.unloadFeaturesGroups:
      return Object.assign({}, state, {
        activeQtCategoryIndex: 0
      });
    case actionTypes.NEW_SCOPE_CATEGORIES_RESET:
      return Object.assign({}, state, {
        qtCategories: [],
        qtCategoriesReceived: false,
        activeQtCategoryIndex: 0
      });
    case actionTypes.NEW_SCOPE_CATEGORIES_SET:
    case actionTypes.NEW_SCOPE_TOGGLE_CATEGORY_IMAGE_POPUP:
    case actionTypes.NEW_SCOPE_TOGGLE_FEATURE_GROUP_IMAGE_POPUP:
    case actionTypes.NEW_SCOPE_SET_ACTIVE_CATEGORY_INDEX:
    case actionTypes.NEW_SCOPE_SET_FEATURE_GROUP_SEARCH_VALUE:
    case actionTypes.NEW_SCOPE_SET_NEW_FEATURE_GROUP_IMAGE:
    case actionTypes.NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS:
    case actionTypes.NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS_RECEIVED:
    case actionTypes.NEW_SCOPE_SET_WIZARD_MODE:
      return Object.assign({}, state, {
        ...action.payload
      });
    case actionTypes.NEW_SCOPE_SET_CATEGORIES_VISUALIZER:
      return Object.assign({}, state, {
        ...action.payload,
        qtCategoriesReceived: false
      });

    default:
      return state;
  }
}
